var _defs, _path, _g, _use, _use2, _use3, _use4, _use5, _use6, _use7, _g2, _g3, _use8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgWorldFlag = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  width: 900,
  height: 50,
  viewBox: "-600 -400 1200 800"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "world_flag_svg__b"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0-200v400h200v-400zm-200 0v400h100v-400z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "world_flag_svg__e"
}, /*#__PURE__*/React.createElement("path", {
  d: "M-200-200h400V50h-400z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "world_flag_svg__f"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0-200-150v300z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "world_flag_svg__g"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0-200-200v400z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "world_flag_svg__i"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0-50-200h-150v350z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "world_flag_svg__j"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0v-200h-200v400z"
})), /*#__PURE__*/React.createElement("circle", {
  id: "world_flag_svg__a",
  r: 145.663,
  fill: "none",
  stroke: "#013ba6",
  strokeWidth: 39.03
}), /*#__PURE__*/React.createElement("circle", {
  id: "world_flag_svg__c",
  r: 145.663,
  fill: "none",
  stroke: "#fff",
  strokeWidth: 17.347
}))), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#013ba6",
  d: "M-600-400H600v800H-600z"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "world_flag_svg__d",
  transform: "translate(145.663)"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#world_flag_svg__a",
  clipPath: "url(#world_flag_svg__b)"
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#world_flag_svg__c"
}))), _use || (_use = /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#world_flag_svg__d",
  transform: "rotate(-60)"
})), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#world_flag_svg__d",
  transform: "rotate(60)"
})), _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#world_flag_svg__d",
  transform: "rotate(120)"
})), _use4 || (_use4 = /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#world_flag_svg__d",
  transform: "rotate(180)"
})), _use5 || (_use5 = /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#world_flag_svg__d",
  transform: "rotate(240)"
})), _use6 || (_use6 = /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#world_flag_svg__a",
  clipPath: "url(#world_flag_svg__e)"
})), _use7 || (_use7 = /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#world_flag_svg__c"
})), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(145.663)"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#world_flag_svg__a",
  clipPath: "url(#world_flag_svg__f)"
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#world_flag_svg__c",
  clipPath: "url(#world_flag_svg__g)"
}))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
  id: "world_flag_svg__k",
  transform: "rotate(120 -72.832 42.05)"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#world_flag_svg__a",
  clipPath: "url(#world_flag_svg__i)"
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#world_flag_svg__c",
  clipPath: "url(#world_flag_svg__j)"
}))), _use8 || (_use8 = /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#world_flag_svg__k",
  transform: "scale(-1 1)"
})));
export default SvgWorldFlag;